import React from "react";
import { Rating } from "react-simple-star-rating";

const CustomerReviews = (props) => {
    const {
        productDataById,
        ratingForm,
        setRatingForm,
        saveRatingData,
        handleRating,
        handleCommentChange,
        handleImageChange,
        removeSelectedImage,
        reviewLoading,
        submitted,
    } = props;

    const rating = Number(productDataById?.average_review || 0);
    const productRating = productDataById?.reviews || [];

    return (
        <div className="review_wrapper_main container-screen">
            <div className="review_section">
                <h2 className="review_heading">
                    Customer Reviews ({productDataById?.reviews_count || productRating?.length || 0})
                </h2>

                <div className="rate_star d-flex justify-content-center get_reviews_rating align-items-center">
                    <Rating
                        initialValue={rating}
                        readonly
                        size={22}
                        label={`Rating: ${rating}`}
                        fractions={2}
                    />
                    <div>
                        <span className="avarage_rating_count">
                            ( {rating} ratings )
                        </span>
                    </div>
                </div>

                <div className="row justify-content-center my-3">
                    <div className="col-xl-6 col-lg-7 col-sm-9 col-12">
                        <div className="rate_star">
                            <label className="rete_label">Rating</label><br />
                            <Rating
                                initialValue={ratingForm?.rating || 0}
                                size={22}
                                onClick={handleRating}
                                fractions={2}
                            />
                        </div>

                        <form onSubmit={saveRatingData} className="mt-3">
                            <div className="row rating_form">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="rete_label">Review</label>
                                        <textarea
                                            className="form-control"
                                            value={ratingForm?.comment || ""}
                                            onChange={handleCommentChange}
                                            placeholder="Leave a remark"
                                        />
                                    </div>
                                </div>

                                <div className="col-12 mt-3">
                                    <div className="form-group">
                                        <label className="rete_label">Upload Images</label>
                                        <div className="upload-wrapper">
                                            <label className="upload-box">
                                                <input
                                                    type="file"
                                                    multiple
                                                    accept="image/*"
                                                    onChange={handleImageChange}
                                                    hidden
                                                />

                                                <div className="upload-content">
                                                    <div className="upload-icon"><i class="fa-solid fa-file"></i></div>
                                                    <p className="upload-text">
                                                        Click to upload images
                                                    </p>
                                                    <span className="upload-subtext">
                                                        PNG, JPG, JPEG (Multiple allowed)
                                                    </span>
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {ratingForm?.imagePreviews?.length > 0 && (
                                    <div className="col-12 mt-3">
                                        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                            {ratingForm.imagePreviews.map((img, index) => (
                                                <div key={index} style={{ position: "relative" }}>
                                                    <img
                                                        src={img}
                                                        alt={`preview-${index}`}
                                                        style={{
                                                            width: "80px",
                                                            height: "80px",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            border: "1px solid #ddd",
                                                        }}
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => removeSelectedImage(index)}
                                                        style={{
                                                            position: "absolute",
                                                            top: "-8px",
                                                            right: "-8px",
                                                            border: "none",
                                                            background: "red",
                                                            color: "#fff",
                                                            borderRadius: "50%",
                                                            width: "22px",
                                                            height: "22px",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        ×
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
{/* 
                                {submitted && (
                                    <div className="col-12 mt-3">
                                        <p style={{ color: "green", marginBottom: 0 }}>
                                            Review submitted successfully!
                                        </p>
                                    </div>
                                )} */}

                                <div className="review_submit_button col-12 mt-3">
                                    <button
                                        type="submit"
                                        className="web_buttons"
                                        disabled={reviewLoading}
                                    >
                                        {reviewLoading ? "Submitting..." : "Submit Review"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="customer_reviews_wrapper_show row justify-content-center pt-5 mt-4">
                <div className="col-sm-9 col-12">
                    {productRating?.map((item, i) => (
                        <div className="review_customer_detail" key={i}>
                            <div className="d-flex justify-content-between align-items-end">
                                <h6 className="review_customer_name mb-0">
                                    {item?.customer?.name || "Customer"}
                                </h6>
                                <p className="review_date mb-0">
                                    {item?.created_at
                                        ? new Date(item.created_at).toLocaleDateString("en-GB")
                                        : "N/A"}
                                </p>
                            </div>

                            <Rating
                                initialValue={item?.rating > 0 ? item?.rating : 0}
                                readonly
                                size={22}
                                label={`Rating: ${item?.rating || 0}`}
                                fractions={2}
                            />

                            <div className="review_customer_comment pt-2">
                                <span>{item?.comment || "-"}</span>
                            </div>

                            {item?.attachment_full_url?.length > 0 && (
                                <div className="pt-2" style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                    {item.attachment_full_url.map((img, index) => (
                                        <img
                                            key={index}
                                            src={img}
                                            alt={`review-${index}`}
                                            style={{
                                                width: "70px",
                                                height: "70px",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                                border: "1px solid #ddd",
                                            }}
                                        />
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CustomerReviews;